import { useMutation } from 'react-query';

import { updatePortalPassword } from '../../lib/api';

export function useMutateUpdatePortalPassword() {
  return useMutation(updatePortalPassword);
}
